<template>
    <section>
        <div class="page">
            <div>
                <h2>Mentioning in a group</h2>
                <p>To specifically mention someone in a message that you're in a group with, type the '@' symbol and
                    select the
                    contact's name. When you mention someone, a notification will be sent to that contact, indicating to
                    them they
                    were referred to.</p>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
